/**
 * Carrega o dataset de pedidos unificados uma vez por tela e separa
 * carregando / erro / dado (Task 12). Mesmo papel do `DatasetBoundary` e do
 * `CatalogBoundary`: nenhuma tela de pedidos repete essa lógica nem confunde
 * erro de carga com "nenhum pedido".
 */
import { createElement as h, type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useOrdersDataset } from "../queries.js";
import type { OrdersDataset } from "../orders/dataset.js";

export interface OrdersBoundaryProps {
  children: (dataset: OrdersDataset) => ReactElement;
}

export function OrdersBoundary({ children }: OrdersBoundaryProps): ReactElement {
  const query = useOrdersDataset();
  if (query.isPending) {
    return h(StatusPanel, { kind: "loading", title: "Carregando pedidos de todos os canais…" });
  }
  if (query.error) {
    return h(StatusPanel, {
      kind: "error",
      title: "Não foi possível carregar os pedidos",
      detail: errorDetail(query.error)
    });
  }
  if (!query.data) {
    return h(StatusPanel, { kind: "empty", title: "Nenhum dado de pedidos retornado pela API da Plataforma" });
  }
  return children(query.data);
}
